import { render } from "./SocialPostsHomePage.vue?vue&type=template&id=679bbad1&scoped=true"
import script from "./SocialPostsHomePage.vue?vue&type=script&lang=js"
export * from "./SocialPostsHomePage.vue?vue&type=script&lang=js"

import "./SocialPostsHomePage.vue?vue&type=style&index=0&id=679bbad1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679bbad1"]])

export default __exports__